import Core from '_abstracts/core'

/**
 *  Chartbeat config
 */

Core.Tasks.add(['user'], () => {
    try {

        const subscriberStatus = ''

        if (Core.User.get('isLogged')) {
            if(Core.User.get('isSubscriber')) {
                subscriberStatus = 'paid'
            } else {
                subscriberStatus = 'lgdin'
            }
        } else {
            subscriberStatus = 'anon'
        }

        var _cbq = window._cbq = (window._cbq || []);
        _cbq.push(['_acct', subscriberStatus]);

    } catch (ex) {
        console.error(ex)
    }
})